/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { scopes } from './scopes'

export const environment = {
  production: false,
  baseUrl: 'https://profile.porsche-preview.com',
  environmentUrlAddition: '/myprofile',
  mock: {
    accessKey: null,
  },
  publicApi: {
    baseUrl: 'https://api.profile.porsche-preview.com/user/v1',
    localisation: 'https://localise.profile.porsche.com',
    signup: 'https://api.signup.porsche-preview.com/',
  },
  mfaApi: {
    baseUrl: 'https://api.access.porsche-preview.com',
  },
  logger: {
    showLogs: true,
    showWarnings: true,
  },
  featureToggles: {
    restrictGlobalUIChanges: true,
    enabled: ['ALLOW_OWNER_NAME_CHANGE'],
  },
  oauth: {
    clientId: 'TPGn30FTB4ubm5quExszUxdqcMfvoumo',
    domain: 'identity.porsche-preview.com',
    authorizationParams: {
      // eslint-disable-next-line camelcase
      redirect_uri: 'https://profile.porsche-preview.com/myprofile/auth/callback',
      audience: 'https://api.porsche-preview.com',
      scope: scopes.join(' '),
    },
    useRefreshTokens: false,
    httpInterceptor: {
      allowedList: [
        'https://api.profile.porsche-preview.com/user/v1*',
        'https://api.access.porsche-preview.com/api/v2/account/mfa/status',
        'https://api.signup.porsche-preview.com/registration/v1*',
      ],
    },
  },
  googleTagManagerV2: {
    enable: true,
    skipInitialPageView: true,
    data: {
      context: {
        applicationId: 'myporsche_idprofile',
        environment: 'PP',
      },
    },
    containerId: 'GTM-W2NKNJZ',
  },
  payment: {
    apiKey: 'TPGn30FTB4ubm5quExszUxdqcMfvoumo',
    view: 'payment-data-management',
    scriptUrl: 'https://pay.porsche-preview.com/widget/v3.3/widget-angular.js',
  },
  externalUrls: {
    connectStore: 'https://preview-connect-store.porsche.com',
    access: 'https://security.porsche-preview.com/auth',
    orders: 'https://myhistory.porsche-preview.com',
  },
  fullstory: {
    devMode: false,
    orgId: 'o-6H95-eu1',
  },
  cookieConsent: {
    enable: true,
    usc: {
      useItpBridge: true,
      enableForLocalhost: false,
    },
  },
  countryLanguageFallback: {
    country: 'en',
    language: 'en',
    locale: 'en_GB',
  },
}
